import React from "react";
import CommonImageSlider from "./comandata";
import { middle, stateBoardImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import { middleToSecondary } from "./faqdata";
import FAQ from "./commonfaq";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";

const reasons = [
    "Proven track record of academic success.",
    "Expert faculty committed to student growth.",
    "Balanced focus on academics, sports, arts, and values.",
    "Integrated competitive exam readiness.",
    "Strong parent–school communication and regular progress updates.",
  ];

  const academics = [
    "CBSE/ICSE-aligned curriculum with conceptual clarity and application-based learning.",
    "Smart classrooms, projects, and hands-on activities to reinforce understanding.",
    "Integrated prep for Olympiads, NTSE, and Science/Math talent exams without extra stress.",
  ];

  const beyondBooks = [
    "Sports & Physical Education – Modern facilities for games, athletics, and fitness.",
    "Arts & Culture – Music, dance, theatre, and visual arts to nurture creativity.",
    "Leadership & Life Skills – Student council, debates, public speaking, and social initiatives.",
    "Personality Development – Confidence-building workshops, etiquette, and teamwork.",
  ];

  const safetyInfra = [
    "Safe, hygienic campus with CCTV and strict safety protocols.",
    "Well-equipped Science and Computer Labs.",
    "Rich library and modern learning tools for research and self-learning.",
  ];
const seopages = {
    title: "Best Secondary School in Hyderabad | Rankridge School",
    description:
      "Rankridge School equips students from Grade 6–10 with solid academics, IIT-JEE & NEET foundation, and competitive exam skills for future success. Enroll today.",
    keywords: "best secondary school hyderabad, grade 6 to 10 school hyderabad, cbse secondary school hyderabad, state board secondary school hyderabad, rankridge secondary school, top high school hyderabad, secondary school admissions hyderabad, academic excellence schools hyderabad, iit jee foundation for school students hyderabad, neet foundation for school students hyderabad, competitive exam coaching schools hyderabad, best high school near me, private secondary school hyderabad, english medium high school hyderabad, holistic secondary education hyderabad, school with science foundation hyderabad, school with math foundation hyderabad, board exam preparation schools hyderabad, top rank schools hyderabad, best academic results schools hyderabad",
    canonical_path: "https://rankridgeschools.com/middle-secondary-education/",
    og_description: "",
    og_image: "",
  };
const title=" Middle & Secondary Education"
 const description="The middle and secondary years are where curiosity meets challenge — where students sharpen their understanding and begin preparing for big goals. At Rankridge Schools, our Middle & Secondary Education programme supports learners from Grade 6 through Grade 10 with care, purpose, and a push toward excellence. Recognized among the best middle schools in Hyderabad, we offer a curriculum that builds strong academics, life skills, and confidence.From Grade 6 onward, students get early exposure to IIT-JEE and NEET foundation courses alongside regular subjects like Science, Mathematics, Languages, and Social Studies. Teachers encourage critical thinking, collaboration, and personal growth through projects, debates, labs, and leadership roles.At Rankridge, this phase is not just about scoring well.it’s about equipping young minds with resilience, curiosity, and the ability to dream big."

const Secondary = () => {
  return (
    <div> 
<h1 className="text-center text-xl font-bold m-3">Rankridge Middle to Secondary School in Hyderabad – Best Education for Grade 6 to 10</h1>

     {/* <CommonImageSlider  images={middle}/> */}
               <CommonAboutHeader  images={middle} title={title} des={description}/>
     
     <section className="mt-4 mb-4">
     <CallandRegisterComponent />
</section>
{/* <h2 className="text-xl text-center sm:text-xl font-semibold text-[black]  m-2">  Empowering Young minds with Excellence, Leadership & Lifelong Values  Rankridge Middle to Secondary School.
    </h2>
<section className="m-4">
        <h2 className="text-2xl font-bold text-center mb-4">
          About Rankridge Middle to Secondary School
        </h2>
        <p className="text-gray-700 text-justify">
          At Rankridge Middle to Secondary School, we understand that the years from Grade 6 to Grade 10
          shape a student’s academic future, personality, and life skills. Recognized as one of the best
          middle schools in Hyderabad and a top secondary school in Hyderabad, our program blends strong
          academics with creativity, leadership training, and values-based education. We prepare students
          for board exams, competitive tests, and real-world challenges while ensuring their emotional and
          social development.
        </p>
      </section> */}

      <div className="bg-[#20b2aa] text-[#20b2aa] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-3 space-y-12">
        {/* Taglines */}
        <div className="text-center max-w-4xl mx-auto text-black">
          <h3 className="text-2xl font-semibold mb-2">
            Rankridge Middle to Secondary School – Where Young Minds Grow into Future Leaders
          </h3>
          <p className="text-lg">Shaping Bright Futures from Grade 6 to Grade 10</p>
          <p className="mt-4">
            Choosing the right school during the middle to secondary years is one of the most important
            decisions for your child’s future. We blend academic excellence with holistic development—building
            confidence, leadership, and a lifelong love for learning—so students excel in board exams,
            competitive tests, and real-world challenges.
          </p>
        </div>

        {/* Why Parents Choose */}
        <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
          <h4 className="text-lg font-bold mb-3 text-black">
            Why Parents Choose Rankridge Middle to Secondary School?
          </h4>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            {reasons.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </div>

        {/* Academics & Competitive Edge */}
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h5 className="text-lg font-bold mb-3 text-black">Academic Excellence That Stands Out</h5>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              {academics.map((a, i) => (
                <li key={i}>{a}</li>
              ))}
            </ul>
          </div>

          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h5 className="text-lg font-bold mb-3 text-black">
              Competitive Exam Preparation – The Rankridge Edge
            </h5>
            <p className="text-gray-700">
              Our dedicated programs for Olympiads, NTSE, and subject-based talent exams are seamlessly woven
              into the timetable. Students learn exam strategies, time management, and problem-solving skills
              without compromising regular academics.
            </p>
          </div>
        </div>

        {/* Beyond Books & Safety/Infra */}
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h5 className="text-lg font-bold mb-3 text-black">
              Beyond Books – Developing Well-Rounded Personalities
            </h5>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              {beyondBooks.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
            <p className="mt-3 text-gray-700">
              Our approach ensures every student is ready for the challenges of higher education and beyond.
            </p>
          </div>

          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h5 className="text-lg font-bold mb-3 text-black">
              Safe, Supportive & Future-Ready Environment
            </h5>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              {safetyInfra.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Proven Track Record */}
        <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
          <h5 className="text-lg font-bold mb-3 text-black">Proven Track Record – Trusted by Parents Across Hyderabad</h5>
          <p className="text-gray-700">
            Consistent top results in board exams and competitive tests. Our alumni pursue higher studies in
            India’s premier institutes and excel in engineering, medicine, business, and more. We balance
            academic discipline with emotional well-being to help students achieve more without burnout.
          </p>
        </div>

        {/* CTA */}
        <div className="space-y-6">
          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h5 className="text-lg font-bold mb-2 text-black">Your Child’s Future Starts Here</h5>
            <p className="text-gray-700">
              Middle to secondary education is the foundation of career, character, and confidence. Choose a
              school that looks beyond marks and shapes responsible, successful, and happy individuals.
            </p>
          </div>

          <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
            <h5 className="text-lg font-bold mb-3 text-black">
              Admissions Open – Grades 6 to 10 (Middle to Secondary)
            </h5>
            <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-sm text-center">
              <div className="bg-[#20b2aa] text-white p-4 rounded-lg">
                <p className="font-semibold font-4">📍 Location</p>
                <p>Hyderabad</p>
              </div>
              <a
                href="tel:+919959303873"
                className="bg-[#20b2aa] text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
              >
                <p className="font-semibold">📞 Call Us</p>
                <p>+91 99 59 303 873</p>
              </a>
              <a
                href="https://www.rankridgeschools.com"
                target="_blank"
                rel="noreferrer"
                className="bg-[#20b2aa] text-white p-4 rounded-lg break-words focus:outline-none focus:ring-2 focus:ring-white"
              >
                <p className="font-semibold">🌐 Visit</p>
                <p>www.rankridgeschools.com</p>
              </a>
            </div>
            <p className="mt-4 text-gray-700">
              Seats for <span className="font-semibold">Grades 6–10</span> are limited — secure your child’s future with
              Rankridge Middle to Secondary Education today!
            </p>
          </div>
        </div>
      </div>


    <FAQ data={middleToSecondary} />
     <SeoMeta seopages={seopages} />
    </div>
  );
};
export default Secondary